import React from 'react';
import { t } from '@lingui/macro';
import { FolderOpenOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import BukkuTooltip from '../Tooltip';

const Styled = styled.div`
  .anticon {
    position: absolute;
    right: 2px;
    bottom: -6px;
    padding: 5px 4.5px 5px 5.5px;
    font-size: 10px;
    color: white;
    background-color: #00a2ae;
    border-radius: 50%;
  }
`;

export function BundleImageTag() {
    return (
        <Styled>
            <BukkuTooltip title={t`Bundle`}>
                <FolderOpenOutlined />
            </BukkuTooltip>
        </Styled>
    );
}
